module.exports = __webpack_public_path__ + "img/4.87d87f2b.jpg";